import {IconType} from '../Icon/IconType.enum';
import {InternalStaticImageType} from './InternalStaticImageType.enum';
import {StaticImageInfo} from './StaticImageInfo.interface';

const INTERNAL_STATIC_IMAGE_INFO_MAP: {
  [key in IconType | InternalStaticImageType]: StaticImageInfo;
} = {
  [IconType.ViewerPlayS]: {
    srcDark: 'ic_viewer_play_s_dark.svg',
    srcLight: 'ic_viewer_play_s.svg',
    alt: '재생',
    width: 24,
    height: 24,
  },
  [IconType.ViewerCloseS]: {
    srcDark: 'ic_viewer_close_s_dark.svg',
    srcLight: 'ic_viewer_close_s.svg',
    alt: '닫기',
    width: 24,
    height: 24,
  },
  [IconType.DefaultProfile]: {
    srcStatic: 'ic-profile-default.svg',
    alt: '프로필',
    width: 80,
    height: 80,
  },
  [IconType.BtnReplayBottom]: {
    srcStatic: 'btn-replay-bottom.svg',
    alt: '다시재생',
    width: 128,
    height: 76,
  },
  [IconType.BtnReplayLeft]: {
    srcStatic: 'btn-replay-left.svg',
    alt: '다시재생',
    width: 142,
    height: 62,
  },
  [IconType.BtnReplayRight]: {
    srcStatic: 'btn-replay-right.svg',
    alt: '다시재생',
    width: 142,
    height: 62,
  },
  [IconType.SoundOn]: {
    srcStatic: 'btn-katalknovel-sound-on.svg',
    alt: '소리 활성화 상태',
    width: 64,
    height: 64,
  },
  [IconType.SoundOff]: {
    srcStatic: 'btn-katalknovel-sound-off.svg',
    alt: '소리 비활성화 상태',
    width: 64,
    height: 64,
  },
  [IconType.BtnVideoPlay]: {
    srcStatic: 'btn-video-play.svg',
    alt: '재생',
    width: 66,
    height: 66,
  },
  [IconType.BtnFullscreenVideoClose]: {
    srcStatic: 'btn-fullscreen-video-close.svg',
    alt: '닫기',
    width: 50,
    height: 50,
  },
  [IconType.StopCount]: {
    srcStatic: 'ic-stop-count.svg',
    alt: '재생 중지',
    width: 26,
    height: 26,
  },
  [IconType.PlayCount]: {
    srcStatic: 'ic-play-count.svg',
    alt: '재생 시작',
    width: 26,
    height: 26,
  },
  [IconType.KatalknovelAfter]: {
    srcStatic: 'ic-katalknovel-after.svg',
    alt: '다음으로',
    width: 62,
    height: 62,
  },
  [IconType.KatalknovelBefore]: {
    srcStatic: 'ic-katalknovel-before.svg',
    alt: '이전으로',
    width: 62,
    height: 62,
  },
  [IconType.BtnFullscreenVideoPause]: {
    srcStatic: 'btn-fullscreen-video-pause.svg',
    alt: '일시정지',
    width: 84,
    height: 84,
  },
  [IconType.BtnFullscreenVideoPlay]: {
    srcStatic: 'btn-fullscreen-video-play.svg',
    alt: '재생',
    width: 84,
    height: 84,
  },
  [IconType.BtnKatalkMenu]: {
    srcStatic: 'btn-katalknovel-search.svg',
    alt: '카톡메뉴',
    width: 64,
    height: 64,
  },
  [IconType.BtnKatalkSearch]: {
    srcStatic: 'btn-katalknovel-menu.svg',
    alt: '카톡검색',
    width: 64,
    height: 64,
  },
  [IconType.NavigationHeartOnStatic]: {
    srcStatic: 'ic_navigation_heart_on_static.svg',
    alt: '좋아요 활성화 상태',
    width: 24,
    height: 24,
  },
  [IconType.NavigationBookmarkOnStatic]: {
    srcStatic: 'ic_navigation_bookmark_on_static.svg',
    alt: '북마크 활성화 상태',
    width: 24,
    height: 24,
  },
  [IconType.NavigationAlarmOnStatic]: {
    srcStatic: 'ic_navigation_alarm_on_static.svg',
    alt: '알림 활성화 상태',
    width: 24,
    height: 24,
  },
  [IconType.NavigationCashFriendsStatic]: {
    srcStatic: 'ic_navigation_cash_friends_static.svg',
    alt: '캐시프렌즈',
    width: 24,
    height: 24,
  },
  [IconType.NavigationHeartOffStatic]: {
    srcStatic: 'ic_navigation_heart_off_static.svg',
    alt: '좋아요 비활성화 상태',
    width: 24,
    height: 24,
  },
  [IconType.NavigationAlarmOffStatic]: {
    srcStatic: 'ic_navigation_alarm_off_static.svg',
    alt: '알림 비활성화 상태',
    width: 24,
    height: 24,
  },
  [IconType.NavigationBackStatic]: {
    srcStatic: 'ic_navigation_back_static.svg',
    alt: '뒤로가기',
    width: 24,
    height: 24,
  },
  [IconType.NavigationSearchStatic]: {
    srcStatic: 'ic_navigation_search_static.svg',
    alt: '검색',
    width: 24,
    height: 24,
  },
  [IconType.NavigationMenuStatic]: {
    srcStatic: 'ic_navigation_menu_static.svg',
    alt: '메뉴',
    width: 24,
    height: 24,
  },
  [IconType.NavigationMoreStatic]: {
    srcStatic: 'ic_navigation_more_static.svg',
    alt: '더보기',
    width: 24,
    height: 24,
  },
  [IconType.NavigationHeartOff]: {
    srcDark: 'ic_navigation_heart_off_dark.svg',
    srcLight: 'ic_navigation_heart_off.svg',
    alt: '좋아요 비활성화 상태',
    width: 24,
    height: 24,
  },
  [IconType.NavigationBookmarkOff]: {
    srcDark: 'ic_navigation_bookmark_off_dark.svg',
    srcLight: 'ic_navigation_bookmark_off.svg',
    alt: '북마크 비활성화 상태',
    width: 24,
    height: 24,
  },
  [IconType.NavigationAlarmOn]: {
    srcDark: 'ic_navigation_alarm_on_dark.svg',
    srcLight: 'ic_navigation_alarm_on.svg',
    alt: '알림 활성화 상태',
    width: 24,
    height: 24,
  },
  [IconType.NavigationAlarmOff]: {
    srcDark: 'ic_navigation_alarm_off_dark.svg',
    srcLight: 'ic_navigation_alarm_off.svg',
    alt: '알림 비활성화 상태',
    width: 24,
    height: 24,
  },
  [IconType.NavigationBack]: {
    srcDark: 'ic_navigation_back_dark.svg',
    srcLight: 'ic_navigation_back.svg',
    alt: '뒤로가기',
    width: 24,
    height: 24,
  },
  [IconType.NavigationClose]: {
    srcDark: 'ic_navigation_close_dark.svg',
    srcLight: 'ic_navigation_close.svg',
    alt: '닫기',
    width: 24,
    height: 24,
  },
  [IconType.NavigationCloseStatic]: {
    srcStatic: 'ic_navigation_close_static.svg',
    alt: '닫기',
    width: 24,
    height: 24,
  },
  [IconType.NavigationSearch]: {
    srcDark: 'ic_navigation_search_dark.svg',
    srcLight: 'ic_navigation_search.svg',
    alt: '검색',
    width: 24,
    height: 24,
  },
  [IconType.NavigationMenu]: {
    srcDark: 'ic_navigation_menu_dark.svg',
    srcLight: 'ic_navigation_menu.svg',
    alt: '메뉴',
    width: 24,
    height: 24,
  },
  [IconType.NavigationMore]: {
    srcDark: 'ic_navigation_more_dark.svg',
    srcLight: 'ic_navigation_more.svg',
    alt: '더보기',
    width: 24,
    height: 24,
  },
  [IconType.NavigationContentsHome]: {
    srcDark: 'ic_navigation_contents_home_dark.svg',
    srcLight: 'ic_navigation_contents_home.svg',
    alt: '컨텐츠홈',
    width: 24,
    height: 24,
  },
  [IconType.NavigationSetting]: {
    srcDark: 'ic_navigation_setting_dark.svg',
    srcLight: 'ic_navigation_setting.svg',
    alt: '설정',
    width: 24,
    height: 24,
  },
  [IconType.NavigationSettingEpub]: {
    srcDark: 'ic_navigation_setting_epub_dark.svg',
    srcLight: 'ic_navigation_setting_epub.svg',
    alt: '이펍 설정',
    width: 24,
    height: 24,
  },
  [IconType.NavigationGift]: {
    srcDark: 'ic_navigation_gift_dark.svg',
    srcLight: 'ic_navigation_gift.svg',
    alt: '선물',
    width: 24,
    height: 24,
  },
  [IconType.NavigationMy]: {
    srcDark: 'ic_navigation_my_dark.svg',
    srcLight: 'ic_navigation_my.svg',
    alt: '내 정보',
    width: 24,
    height: 24,
  },
  [IconType.NavigationHomeStatic]: {
    srcStatic: 'ic_navigation_home_static.svg',
    alt: '홈',
    width: 24,
    height: 24,
  },
  [IconType.NavigationArrowLeft]: {
    srcDark: 'ic_navigation_arrow_left_dark.svg',
    srcLight: 'ic_navigation_arrow_left.svg',
    alt: '왼쪽 화살표',
    width: 24,
    height: 24,
  },
  [IconType.NavigationArrowRight]: {
    srcDark: 'ic_navigation_arrow_right_dark.svg',
    srcLight: 'ic_navigation_arrow_right.svg',
    alt: '오른쪽 화살표',
    width: 24,
    height: 24,
  },
  [IconType.TabFilter]: {
    srcLight: 'ic_tab_filter.svg',
    srcDark: 'ic_tab_filter_dark.svg',
    alt: '필터',
    width: 12,
    height: 12,
  },
  [IconType.TabSorting]: {
    srcLight: 'ic_tab_sorting.svg',
    srcDark: 'ic_tab_sorting_dark.svg',
    alt: '정렬',
    width: 12,
    height: 12,
  },
  [IconType.TabCheckOn]: {
    srcLight: 'ic_tab_check_on.svg',
    srcDark: 'ic_tab_check_on_dark.svg',
    alt: '체크박스 활성화 상태',
    width: 12,
    height: 12,
  },
  [IconType.TabCheckOff]: {
    srcLight: 'ic_tab_check_off.svg',
    srcDark: 'ic_tab_check_off_dark.svg',
    alt: '체크박스 비활성화 상태',
    width: 12,
    height: 12,
  },
  [IconType.TabGiftList]: {
    srcLight: 'ic_tab_gift_list.svg',
    srcDark: 'ic_tab_gift_list_dark.svg',
    alt: '받은선물 내역',
    width: 12,
    height: 12,
  },
  [IconType.NavigationHome]: {
    srcDark: 'ic_navigation_home_dark.svg',
    srcLight: 'ic_navigation_home.svg',
    alt: '홈',
    width: 24,
    height: 24,
  },
  [IconType.NavigationCabinet]: {
    srcDark: 'ic_navigation_cabinet_dark.svg',
    srcLight: 'ic_navigation_cabinet.svg',
    alt: '보관함',
    width: 24,
    height: 24,
  },
  [IconType.NavigationCabinetWeb]: {
    srcDark: 'ic_navigation_cabinet_web_dark.svg',
    srcLight: 'ic_navigation_cabinet_web.svg',
    alt: '보관함',
    width: 24,
    height: 24,
  },
  [IconType.NavigationPage]: {
    srcDark: 'ic_navigation_page_dark.svg',
    srcLight: 'ic_navigation_page.svg',
    alt: '페이지',
    width: 24,
    height: 24,
  },
  [IconType.NavigationScroll]: {
    srcDark: 'ic_navigation_scroll_dark.svg',
    srcLight: 'ic_navigation_scroll.svg',
    alt: '스크롤',
    width: 24,
    height: 24,
  },
  [IconType.NavigationStageMwStatic]: {
    srcStatic: 'ic_navigation_stage_mw_static.svg',
    alt: '스테이지',
    width: 24,
    height: 24,
  },
  [IconType.NavigationStagePcStatic]: {
    srcStatic: 'ic_navigation_stage_pc_static.svg',
    alt: '스테이지',
    width: 48,
    height: 24,
  },
  [IconType.TabArrowDown]: {
    srcDark: 'ic_tab_arrow_down_dark.svg',
    srcLight: 'ic_tab_arrow_down.svg',
    alt: '아래 화살표',
    width: 12,
    height: 12,
  },
  [IconType.TabArrowUp]: {
    srcDark: 'ic_tab_arrow_up_dark.svg',
    srcLight: 'ic_tab_arrow_up.svg',
    alt: '위 화살표',
    width: 12,
    height: 12,
  },
  [IconType.ListArrowRight]: {
    srcDark: 'ic_list_arrow_right_dark.svg',
    srcLight: 'ic_list_arrow_right.svg',
    alt: '다음',
    width: 24,
    height: 24,
  },
  [IconType.ListArrowDown]: {
    srcDark: 'ic_list_arrow_down_dark.svg',
    srcLight: 'ic_list_arrow_down.svg',
    alt: '아래 화살표',
    width: 24,
    height: 24,
  },
  [IconType.ListArrowUp]: {
    srcDark: 'ic_list_arrow_up_dark.svg',
    srcLight: 'ic_list_arrow_up.svg',
    alt: '위 화살표',
    width: 24,
    height: 24,
  },
  [IconType.ListBannerSlashStatic]: {
    srcStatic: 'ic_list_banner_slash_static.svg',
    alt: '슬래시',
    width: 12,
    height: 12,
  },
  [IconType.MenuAlarm]: {
    srcDark: 'ic_menu_alarm_dark.svg',
    srcLight: 'ic_menu_alarm.svg',
    alt: '알림',
    width: 24,
    height: 24,
  },
  [IconType.MenuComment]: {
    srcDark: 'ic_menu_comment_dark.svg',
    srcLight: 'ic_menu_comment.svg',
    alt: '댓글',
    width: 24,
    height: 24,
  },
  [IconType.MenuCouponRegister]: {
    srcDark: 'ic_menu_coupon_register_dark.svg',
    srcLight: 'ic_menu_coupon_register.svg',
    alt: '쿠폰등록',
    width: 24,
    height: 24,
  },
  [IconType.MenuCash]: {
    srcDark: 'ic_menu_cash_dark.svg',
    srcLight: 'ic_menu_cash.svg',
    alt: '캐시',
    width: 24,
    height: 24,
  },
  [IconType.MenuCashPassVip]: {
    srcDark: 'ic_menu_cash_pass_vip_dark.svg',
    srcLight: 'ic_menu_cash_pass_vip.svg',
    alt: '캐시 Pass Vip',
    width: 24,
    height: 24,
  },
  [IconType.MenuCoupon]: {
    srcDark: 'ic_menu_coupon_dark.svg',
    srcLight: 'ic_menu_coupon.svg',
    alt: '쿠폰',
    width: 24,
    height: 24,
  },
  [IconType.MenuNotice]: {
    srcDark: 'ic_menu_notice_dark.svg',
    srcLight: 'ic_menu_notice.svg',
    alt: '공지사항',
    width: 24,
    height: 24,
  },
  [IconType.MenuCustomer]: {
    srcDark: 'ic_menu_customer_dark.svg',
    srcLight: 'ic_menu_customer.svg',
    alt: '고객센터',
    width: 24,
    height: 24,
  },
  [IconType.MenuSetting]: {
    srcDark: 'ic_menu_setting_dark.svg',
    srcLight: 'ic_menu_setting.svg',
    alt: '설정',
    width: 24,
    height: 24,
  },
  [IconType.MenuColorMode]: {
    srcDark: 'ic_menu_color_mode_dark.svg',
    srcLight: 'ic_menu_color_mode.svg',
    alt: '컬러모드',
    width: 24,
    height: 24,
  },
  [IconType.BadgeFreeStatic]: {
    srcStatic: 'ic_badge_free_static.svg',
    alt: '완전무료 뱃지',
    width: 38,
    height: 16,
  },
  [IconType.Badge0HourStatic]: {
    srcStatic: 'ic_badge_0time_static.svg',
    alt: '0다무 뱃지',
    width: 44,
    height: 16,
  },
  [IconType.Badge1HourStatic]: {
    srcStatic: 'ic_badge_1time_static.svg',
    alt: '1다무 뱃지',
    width: 44,
    height: 16,
  },
  [IconType.Badge2HourStatic]: {
    srcStatic: 'ic_badge_2time_static.svg',
    alt: '2다무 뱃지',
    width: 44,
    height: 16,
  },
  [IconType.Badge3HourStatic]: {
    srcStatic: 'ic_badge_3time_static.svg',
    alt: '3다무 뱃지',
    width: 44,
    height: 16,
  },
  [IconType.BadgeNewStatic]: {
    srcStatic: 'ic_badge_new_static.svg',
    alt: '신작 뱃지',
    width: 20,
    height: 16,
  },
  [IconType.BadgeUpStatic]: {
    srcStatic: 'ic_badge_up_static.svg',
    alt: '새 회차 뱃지',
    width: 20,
    height: 16,
  },
  [IconType.Badge15Static]: {
    srcStatic: 'ic_badge_15_static.svg',
    alt: '15세 뱃지',
    width: 16,
    height: 16,
  },
  [IconType.Badge19Static]: {
    srcStatic: 'ic_badge_19_static.svg',
    alt: '19세 뱃지',
    width: 16,
    height: 16,
  },
  [IconType.BadgeAdultStatic]: {
    srcStatic: 'ic_badge_adult_static.svg',
    alt: '성인 뱃지',
    width: 26,
    height: 16,
  },
  [IconType.BadgeEventStatic]: {
    srcStatic: 'ic_badge_event_static.svg',
    alt: '이벤트 뱃지',
    width: 36,
    height: 16,
  },
  [IconType.BadgeTimeStatic]: {
    srcStatic: 'ic_badge_time_static.svg',
    alt: '기다무 뱃지',
    width: 16,
    height: 16,
  },
  [IconType.BadgeFree]: {
    srcDark: 'ic_badge_free_dark.svg',
    srcLight: 'ic_badge_free.svg',
    alt: '무료 뱃지',
    width: 26,
    height: 16,
  },
  [IconType.BadgeNew]: {
    srcDark: 'ic_badge_new_dark.svg',
    srcLight: 'ic_badge_new.svg',
    alt: '신작 뱃지',
    width: 16,
    height: 16,
  },
  [IconType.BadgeUp]: {
    srcDark: 'ic_badge_up_dark.svg',
    srcLight: 'ic_badge_up.svg',
    alt: '새 회차 뱃지',
    width: 20,
    height: 16,
  },
  [IconType.BadgeLock]: {
    srcDark: 'ic_badge_lock_dark.svg',
    srcLight: 'ic_badge_lock.svg',
    alt: '잠금 뱃지',
    width: 16,
    height: 16,
  },
  [IconType.BadgeUnlock]: {
    srcDark: 'ic_badge_unlock_dark.svg',
    srcLight: 'ic_badge_unlock.svg',
    alt: '잠금해제 뱃지',
    width: 16,
    height: 16,
  },
  [IconType.Badge19SelfStatic]: {
    srcStatic: 'ic_badge_19self_static.svg',
    alt: '자율심의 19세 뱃지',
    width: 16,
    height: 16,
  },
  [IconType.BadgeNovelStatic]: {
    srcStatic: 'ic_badge_novel_static.svg',
    alt: '웹소설/책 뱃지',
    width: 38,
    height: 40,
  },
  [IconType.RankingNewStatic]: {
    srcStatic: 'ic_ranking_new_static.svg',
    alt: 'NEW',
    width: 20,
    height: 16,
  },
  [IconType.RankingArrowDownStatic]: {
    srcStatic: 'ic_ranking_arrow_down_static.svg',
    alt: '아래 화살표',
    width: 12,
    height: 12,
  },
  [IconType.RankingArrowUpStatic]: {
    srcStatic: 'ic_ranking_arrow_up_static.svg',
    alt: '위 화살표',
    width: 12,
    height: 12,
  },
  [IconType.RankingStayStatic]: {
    srcStatic: 'ic_ranking_stay_static.svg',
    alt: '유지',
    width: 12,
    height: 12,
  },
  [IconType.ListArrowDownStatic]: {
    srcStatic: 'ic_list_arrow_down_static.svg',
    alt: '아래 화살표',
    width: 24,
    height: 24,
  },
  [IconType.ListArrowUpStatic]: {
    srcStatic: 'ic_list_arrow_up_static.svg',
    alt: '위 화살표',
    width: 24,
    height: 24,
  },
  [IconType.TitleBarArrowRight]: {
    srcDark: 'ic_title_bar_arrow_right_dark.svg',
    srcLight: 'ic_title_bar_arrow_right.svg',
    alt: '다음',
    width: 24,
    height: 24,
  },
  [IconType.ButtonCloseSolidSStatic]: {
    srcStatic: 'ic_button_close_solid_s_static.svg',
    alt: '닫기',
    width: 12,
    height: 12,
  },
  [IconType.ButtonCloseSolidMPcStatic]: {
    srcStatic: 'ic_button_close_solid_m_pc_static.svg',
    alt: '닫기',
    width: 24,
    height: 24,
  },
  [IconType.ButtonCashFriendsStatic]: {
    srcStatic: 'ic_button_cash_friends_static.svg',
    alt: '캐시프렌즈',
    width: 24,
    height: 24,
  },
  [IconType.ButtonKakaoLogoStatic]: {
    srcStatic: 'ic_button_kakao_logo_static.svg',
    alt: '카카오 로고',
    width: 24,
    height: 24,
  },
  [IconType.ButtonCloseMStatic]: {
    srcStatic: 'ic_button_close_m_static.svg',
    alt: '닫기',
    width: 24,
    height: 24,
  },
  [IconType.ButtonCloseSolidS]: {
    srcDark: 'ic_button_close_solid_s_dark.svg',
    srcLight: 'ic_button_close_solid_s.svg',
    alt: '닫기',
    width: 12,
    height: 12,
  },
  [IconType.ButtonArrowS]: {
    srcDark: 'ic_button_arrow_s_dark.svg',
    srcLight: 'ic_button_arrow_s.svg',
    alt: '다음',
    width: 12,
    height: 12,
  },
  [IconType.ButtonArrowLeft]: {
    srcDark: 'ic_button_arrow_left_dark.svg',
    srcLight: 'ic_button_arrow_left.svg',
    alt: '이전',
    width: 12,
    height: 12,
  },
  [IconType.ButtonArrowRight]: {
    srcDark: 'ic_button_arrow_right_dark.svg',
    srcLight: 'ic_button_arrow_right.svg',
    alt: '다음',
    width: 12,
    height: 12,
  },
  [IconType.ButtonArrowUp]: {
    srcDark: 'ic_button_arrow_up_dark.svg',
    srcLight: 'ic_button_arrow_up.svg',
    alt: '열림',
    width: 12,
    height: 12,
  },
  [IconType.ButtonArrowDown]: {
    srcDark: 'ic_button_arrow_down_dark.svg',
    srcLight: 'ic_button_arrow_down.svg',
    alt: '닫힘',
    width: 12,
    height: 12,
  },
  [IconType.ButtonArrowRightYellowStatic]: {
    srcStatic: 'ic_button_arrow_right_yellow_static.svg',
    alt: '다음',
    width: 12,
    height: 12,
  },
  [IconType.ButtonCloseS]: {
    srcDark: 'ic_button_close_s_dark.svg',
    srcLight: 'ic_button_close_s.svg',
    alt: '닫기',
    width: 12,
    height: 12,
  },
  [IconType.ButtonPlusM]: {
    srcDark: 'ic_button_plus_m_dark.svg',
    srcLight: 'ic_button_plus_m.svg',
    alt: '플러스',
    width: 24,
    height: 24,
  },
  [IconType.ButtonMinus]: {
    srcDark: 'ic_button_minus_dark.svg',
    srcLight: 'ic_button_minus.svg',
    alt: '마이너스',
    width: 24,
    height: 24,
  },
  [IconType.ButtonMoreStatic]: {
    srcStatic: 'ic_button_more_static.svg',
    alt: '더보기',
    width: 16,
    height: 16,
  },
  [IconType.ButtonMoreArrowStatic]: {
    srcStatic: 'ic_button_more_arrow_static.svg',
    alt: '더보기',
    width: 16,
    height: 16,
  },
  [IconType.ButtonPlusL]: {
    srcDark: 'ic_button_plus_l_dark.svg',
    srcLight: 'ic_button_plus_l.svg',
    alt: '플러스',
    width: 24,
    height: 24,
  },
  [IconType.ButtonShare]: {
    srcDark: 'ic_button_share_dark.svg',
    srcLight: 'ic_button_share.svg',
    alt: '공유',
    width: 24,
    height: 24,
  },
  [IconType.ButtonArrowLeftMStatic]: {
    srcStatic: 'ic_button_arrow_left_m_static.svg',
    alt: '이전',
    width: 20,
    height: 20,
  },
  [IconType.ButtonArrowRightMStatic]: {
    srcStatic: 'ic_button_arrow_right_m_static.svg',
    alt: '다음',
    width: 20,
    height: 20,
  },
  [IconType.ButtonArrowLeftLStatic]: {
    srcStatic: 'ic_button_arrow_left_l_static.svg',
    alt: '이전',
    width: 12,
    height: 18,
  },
  [IconType.ButtonArrowRightLStatic]: {
    srcStatic: 'ic_button_arrow_right_l_static.svg',
    alt: '다음',
    width: 12,
    height: 18,
  },

  [IconType.ButtonNotice]: {
    srcDark: 'ic_button_notice_dark.svg',
    srcLight: 'ic_button_notice.svg',
    alt: '안내',
    width: 12,
    height: 12,
  },
  [IconType.ButtonHelpS]: {
    srcDark: 'ic_button_help_s_dark.svg',
    srcLight: 'ic_button_help_s.svg',
    alt: '안내',
    width: 12,
    height: 12,
  },
  [IconType.ButtonHelpS2]: {
    srcDark: 'ic_button_help_s_02_dark.svg',
    srcLight: 'ic_button_help_s_02.svg',
    alt: '안내',
    width: 12,
    height: 12,
  },
  [IconType.ButtonHelpM]: {
    srcDark: 'ic_button_help_m_dark.svg',
    srcLight: 'ic_button_help_m.svg',
    alt: '안내',
    width: 14,
    height: 14,
  },
  [IconType.ListHeartOnStatic]: {
    srcStatic: 'ic_list_heart_on_static.svg',
    alt: '좋아요 활성화 상태',
    width: 18,
    height: 18,
  },
  [IconType.ListHeartOn]: {
    srcLight: 'ic_list_heart_on.svg',
    srcDark: 'ic_list_heart_on_dark.svg',
    alt: '좋아요 활성화 상태',
    width: 16,
    height: 16,
  },
  [IconType.ListCommentOnStatic]: {
    srcStatic: 'ic_list_comment_on_static.svg',
    alt: '댓글 활성화 상태',
    width: 18,
    height: 18,
  },
  [IconType.ListCommentOn]: {
    srcLight: 'ic_list_comment_on.svg',
    srcDark: 'ic_list_comment_on_dark.svg',
    alt: '댓글 활성화 상태',
    width: 16,
    height: 16,
  },
  [IconType.ListBookmarkOnStatic]: {
    srcStatic: 'ic_list_bookmark_on_static.svg',
    alt: '북마크 활성화 상태',
    width: 18,
    height: 18,
  },
  [IconType.ListHeartOff]: {
    srcDark: 'ic_list_heart_off_dark.svg',
    srcLight: 'ic_list_heart_off.svg',
    alt: '좋아요 비활성화 상태',
    width: 16,
    height: 16,
  },
  [IconType.ListCommentOff]: {
    srcDark: 'ic_list_comment_off_dark.svg',
    srcLight: 'ic_list_comment_off.svg',
    alt: '댓글 비활성화 상태',
    width: 16,
    height: 16,
  },
  [IconType.ListBookmarkOff]: {
    srcDark: 'ic_list_bookmark_off_dark.svg',
    srcLight: 'ic_list_bookmark_off.svg',
    alt: '북마크 비활성화 상태',
    width: 18,
    height: 18,
  },
  [IconType.ListClose]: {
    srcDark: 'ic_list_close_dark.svg',
    srcLight: 'ic_list_close.svg',
    alt: '닫기',
    width: 16,
    height: 16,
  },
  [IconType.ListMore]: {
    srcDark: 'ic_list_more_dark.svg',
    srcLight: 'ic_list_more.svg',
    alt: '더보기',
    width: 16,
    height: 16,
  },
  [IconType.ListReply]: {
    srcDark: 'ic_list_reply_dark.svg',
    srcLight: 'ic_list_reply.svg',
    alt: '답글',
    width: 12,
    height: 12,
  },
  [IconType.ListCommentCloseMw]: {
    srcDark: 'ic_list_comment_close_mw_dark.svg',
    srcLight: 'ic_list_comment_close_mw.svg',
    alt: '댓글 닫기',
    width: 16,
    height: 16,
  },
  [IconType.ListCommentClose02Mw]: {
    srcDark: 'ic_list_comment_close_02_mw_dark.svg',
    srcLight: 'ic_list_comment_close_02_mw.svg',
    alt: '댓글 닫기',
    width: 16,
    height: 16,
  },
  [IconType.ListMetadataDot]: {
    srcDark: 'ic_list_metadata_dot_dark.svg',
    srcLight: 'ic_list_metadata_dot.svg',
    alt: '메타데이터 구분점',
    width: 8,
    height: 16,
  },
  [IconType.ListMetadataDotStatic]: {
    srcDark: 'ic_list_metadata_dot_static.svg',
    srcLight: 'ic_list_metadata_dot_static.svg',
    alt: '메타데이터 구분점',
    width: 8,
    height: 16,
  },
  [IconType.CheckBoxSOnStatic]: {
    srcStatic: 'ic_check_box_s_on_static.svg',
    alt: '체크박스 활성화 상태',
    width: 12,
    height: 12,
  },
  [IconType.CheckBoxMOnStatic]: {
    srcStatic: 'ic_check_box_m_on_static.svg',
    alt: '체크박스 활성화 상태',
    width: 18,
    height: 18,
  },
  [IconType.CheckBoxLOnStatic]: {
    srcStatic: 'ic_check_box_l_on_static.svg',
    alt: '체크박스 활성화 상태',
    width: 24,
    height: 24,
  },
  [IconType.CheckBoxSOff]: {
    srcDark: 'ic_check_box_s_off_dark.svg',
    srcLight: 'ic_check_box_s_off.svg',
    alt: '체크박스 비활성화 상태',
    width: 12,
    height: 12,
  },
  [IconType.CheckBoxMOff]: {
    srcDark: 'ic_check_box_m_off_dark.svg',
    srcLight: 'ic_check_box_m_off.svg',
    alt: '체크박스 비활성화 상태',
    width: 18,
    height: 18,
  },
  [IconType.CheckBoxLOff]: {
    srcDark: 'ic_check_box_l_off_dark.svg',
    srcLight: 'ic_check_box_l_off.svg',
    alt: '체크박스 비활성화 상태',
    width: 24,
    height: 24,
  },
  [IconType.CheckOn]: {
    srcDark: 'ic_check_on_dark.svg',
    srcLight: 'ic_check_on.svg',
    alt: '체크 활성화 상태',
    width: 16,
    height: 16,
  },
  [IconType.CheckOff]: {
    srcDark: 'ic_check_off_dark.svg',
    srcLight: 'ic_check_off.svg',
    alt: '체크 비활성화 상태',
    width: 16,
    height: 16,
  },
  [IconType.RadioOff]: {
    srcDark: 'ic_radio_off_dark.svg',
    srcLight: 'ic_radio_off.svg',
    alt: '라디오 버튼 비활성화 상태',
    width: 18,
    height: 18,
  },
  [IconType.RadioOffV2]: {
    srcDark: 'ic_radio_off_dark_v2.svg',
    srcLight: 'ic_radio_off_v2.svg',
    alt: '라디오 버튼 비활성화 상태',
    width: 16,
    height: 16,
  },
  [IconType.RadioOnStatic]: {
    srcStatic: 'ic_radio_on_static.svg',
    alt: '라디오 버튼 활성화 상태',
    width: 18,
    height: 18,
  },
  [IconType.RadioOnV2]: {
    srcDark: 'ic_radio_on_dark_v2.svg',
    srcLight: 'ic_radio_on_v2.svg',
    alt: '라디오 버튼 활성화 상태',
    width: 16,
    height: 16,
  },
  [IconType.PlayerPlayStatic]: {
    srcStatic: 'ic_player_play_static.svg',
    alt: '재생',
    width: 24,
    height: 24,
  },
  [IconType.PlayerSoundStatic]: {
    srcStatic: 'ic_player_sound_static.svg',
    alt: '사운드 상태',
    width: 24,
    height: 24,
  },
  [IconType.PlayerMuteStatic]: {
    srcStatic: 'ic_player_mute_static.svg',
    alt: '음소거 상태',
    width: 24,
    height: 24,
  },
  [IconType.PlayerPlaySolidStatic]: {
    srcStatic: 'ic_player_play_solid_static.svg',
    alt: '재생',
    width: 20,
    height: 20,
  },
  [IconType.PlayerPlaySolidLStatic]: {
    srcStatic: 'ic_player_play_solid_l_static.svg',
    alt: '재생',
    width: 24,
    height: 24,
  },
  [IconType.EditSolidStatic]: {
    srcStatic: 'ic_edit_solid_static.svg',
    alt: '편집',
    width: 28,
    height: 28,
  },
  [IconType.PopupCheck]: {
    srcDark: 'ic_popup_check_dark.svg',
    srcLight: 'ic_popup_check.svg',
    alt: '체크',
    width: 24,
    height: 24,
  },
  [IconType.ModalCheck]: {
    srcDark: 'ic_modal_check_dark.svg',
    srcLight: 'ic_modal_check.svg',
    alt: '체크',
    width: 24,
    height: 24,
  },
  [IconType.ModalCheckStatic]: {
    srcStatic: 'ic_modal_check_static.svg',
    alt: '체크',
    width: 24,
    height: 24,
  },
  [IconType.ModalKakaoLogo]: {
    srcDark: 'ic_modal_kakao_logo_dark.svg',
    srcLight: 'ic_modal_kakao_logo.svg',
    alt: '카카오',
    width: 24,
    height: 24,
  },
  [IconType.ModalFacebookLogo]: {
    srcDark: 'ic_modal_facebook_logo_dark.svg',
    srcLight: 'ic_modal_facebook_logo.svg',
    alt: '페이스북',
    width: 24,
    height: 24,
  },
  [IconType.ModalLink]: {
    srcDark: 'ic_modal_link_dark.svg',
    srcLight: 'ic_modal_link.svg',
    alt: '링크',
    width: 24,
    height: 24,
  },
  [IconType.ModalTwitterLogo]: {
    srcDark: 'ic_modal_twitter_logo_dark.svg',
    srcLight: 'ic_modal_twitter_logo.svg',
    alt: '트위터',
    width: 24,
    height: 24,
  },
  [IconType.TopSolid]: {
    srcDark: 'ic_top_solid_dark.svg',
    srcLight: 'ic_top_solid.svg',
    alt: '상단 이동',
    width: 30,
    height: 30,
  },
  [IconType.SearchArrowDownStatic]: {
    srcStatic: 'ic_search_arrow_down_static.svg',
    alt: '감소',
    width: 12,
    height: 12,
  },
  [IconType.SearchArrowUpStatic]: {
    srcStatic: 'ic_search_arrow_up_static.svg',
    alt: '상승',
    width: 12,
    height: 12,
  },
  [IconType.SearchStayStatic]: {
    srcStatic: 'ic_search_stay_static.svg',
    alt: '유지',
    width: 12,
    height: 12,
  },
  [IconType.Search]: {
    srcDark: 'ic_search_dark.svg',
    srcLight: 'ic_search.svg',
    alt: '검색',
    width: 24,
    height: 24,
  },
  [IconType.SearchList]: {
    srcDark: 'ic_search_list_dark.svg',
    srcLight: 'ic_search_list.svg',
    alt: '검색',
    width: 24,
    height: 24,
  },
  [IconType.SearchListButton]: {
    srcDark: 'ic_search_list_button_dark.svg',
    srcLight: 'ic_search_list_button.svg',
    alt: '검색',
    width: 24,
    height: 24,
  },
  [IconType.SearchButton]: {
    srcDark: 'ic_search_button_dark.svg',
    srcLight: 'ic_search_button.svg',
    alt: '검색',
    width: 24,
    height: 24,
  },
  [IconType.ContentHomeHelpSolidStatic]: {
    srcStatic: 'ic_content_home_help_solid_static.svg',
    alt: '도움말',
    width: 16,
    height: 16,
  },
  [IconType.ContentHomeNoticeSolidStatic]: {
    srcStatic: 'ic_content_home_notice_solid_static.svg',
    alt: '공지',
    width: 16,
    height: 16,
  },
  [IconType.PcContentHomeNoticeSolidStatic]: {
    srcStatic: 'ic_content_home_notice_solid_static.svg',
    alt: '공지',
    width: 16,
    height: 16,
  },
  [IconType.ContentHomeBook]: {
    srcDark: 'ic_content_home_book_dark.svg',
    srcLight: 'ic_content_home_book.svg',
    alt: '책',
    width: 16,
    height: 16,
  },
  [IconType.ContentHomeChat]: {
    srcDark: 'ic_content_home_chat_dark.svg',
    srcLight: 'ic_content_home_chat.svg',
    alt: '채팅소설',
    width: 16,
    height: 16,
  },
  [IconType.ContentHomeNovel]: {
    srcDark: 'ic_content_home_novel_dark.svg',
    srcLight: 'ic_content_home_novel.svg',
    alt: '소설',
    width: 16,
    height: 16,
  },
  [IconType.ContentHomeComic]: {
    srcDark: 'ic_content_home_comic_dark.svg',
    srcLight: 'ic_content_home_comic.svg',
    alt: '웹툰',
    width: 16,
    height: 16,
  },
  [IconType.ContentHomeView]: {
    srcDark: 'ic_content_home_view_dark.svg',
    srcLight: 'ic_content_home_view.svg',
    alt: '열람자',
    width: 16,
    height: 16,
  },
  [IconType.ContentHomeStar]: {
    srcDark: 'ic_content_home_star_dark.svg',
    srcLight: 'ic_content_home_star.svg',
    alt: '별점',
    width: 16,
    height: 16,
  },
  [IconType.ContentHomeStarPc]: {
    srcDark: 'ic_content_home_star_pc_dark.svg',
    srcLight: 'ic_content_home_star_pc.svg',
    alt: '별점',
    width: 17,
    height: 16,
  },
  [IconType.ContentHomeNewStatic]: {
    srcStatic: 'ic_content_home_new_static.svg',
    alt: '새 회차',
    width: 12,
    height: 12,
  },
  [IconType.ContentHomeHelp]: {
    srcDark: 'ic_content_home_help_dark.svg',
    srcLight: 'ic_content_home_help.svg',
    alt: '도움말',
    width: 14,
    height: 14,
  },
  [IconType.ContentHomeHelpSolid]: {
    srcDark: 'ic_content_home_help_solid_dark.svg',
    srcLight: 'ic_content_home_help_solid.svg',
    alt: '도움말',
    width: 12,
    height: 12,
  },
  [IconType.ContentHomeTime]: {
    srcDark: 'ic_content_home_time_dark.svg',
    srcLight: 'ic_content_home_time.svg',
    alt: '기다무',
    width: 20,
    height: 20,
  },
  [IconType.ContentHomeCoupon]: {
    srcDark: 'ic_content_home_coupon_dark.svg',
    srcLight: 'ic_content_home_coupon.svg',
    alt: '쿠폰',
    width: 20,
    height: 20,
  },
  [IconType.ContentHomeRightArrow]: {
    srcDark: 'ic_content_home_right_arrow_dark.svg',
    srcLight: 'ic_content_home_right_arrow.svg',
    alt: '쿠폰',
    width: 14,
    height: 14,
  },
  [IconType.ContentHomeScroll]: {
    srcDark: 'ic_content_home_scroll_dark.svg',
    srcLight: 'ic_content_home_scroll.svg',
    alt: '스크롤',
    width: 12,
    height: 24,
  },
  [IconType.ContentHomeLowRank]: {
    srcDark: 'ic_content_home_low_rank_dark.svg',
    srcLight: 'ic_content_home_low_rank.svg',
    alt: '하위요소',
    width: 16,
    height: 16,
  },
  [IconType.ContentHomeMark]: {
    srcDark: 'ic_content_home_mark_dark.svg',
    srcLight: 'ic_content_home_mark.svg',
    alt: '마크',
    width: 14,
    height: 14,
  },
  [IconType.ContentHomeMarkPc]: {
    srcDark: 'ic_content_home_mark_pc_dark.svg',
    srcLight: 'ic_content_home_mark_pc.svg',
    alt: '마크',
    width: 14,
    height: 14,
  },
  [IconType.ContentHome0Hour]: {
    srcDark: 'ic_content_home_0time_dark.svg',
    srcLight: 'ic_content_home_0time.svg',
    alt: '0다무',
    width: 52,
    height: 18,
  },
  [IconType.ContentHome1Hour]: {
    srcDark: 'ic_content_home_1time_dark.svg',
    srcLight: 'ic_content_home_1time.svg',
    alt: '1다무',
    width: 52,
    height: 18,
  },
  [IconType.ContentHome2Hour]: {
    srcDark: 'ic_content_home_2time_dark.svg',
    srcLight: 'ic_content_home_2time.svg',
    alt: '2다무',
    width: 52,
    height: 18,
  },
  [IconType.ContentHome3Hour]: {
    srcDark: 'ic_content_home_3time_dark.svg',
    srcLight: 'ic_content_home_3time.svg',
    alt: '3다무',
    width: 52,
    height: 18,
  },
  [IconType.ContentHome0HourStatic]: {
    srcStatic: 'ic_content_home_0time_static.svg',
    alt: '0다무',
    width: 52,
    height: 18,
  },
  [IconType.ContentHome1HourStatic]: {
    srcStatic: 'ic_content_home_1time_static.svg',
    alt: '1다무',
    width: 52,
    height: 18,
  },
  [IconType.ContentHome2HourStatic]: {
    srcStatic: 'ic_content_home_2time_static.svg',
    alt: '2다무',
    width: 52,
    height: 18,
  },
  [IconType.ContentHome3HourStatic]: {
    srcStatic: 'ic_content_home_3time_static.svg',
    alt: '3다무',
    width: 52,
    height: 18,
  },
  [IconType.ContentHomeComment]: {
    srcDark: 'ic_content_home_comment_dark.svg',
    srcLight: 'ic_content_home_comment.svg',
    alt: '댓글',
    width: 20,
    height: 20,
  },
  [IconType.ContentHomeMoreLine]: {
    srcDark: 'ic_content_home_more_line_dark.svg',
    srcLight: 'ic_content_home_more_line.svg',
    alt: '더보기',
    width: 14,
    height: 14,
  },
  [IconType.ContentHomeDivider]: {
    srcDark: 'ic_content_home_divider_dark.svg',
    srcLight: 'ic_content_home_divider.svg',
    alt: '리스트 구분자',
    width: 18,
    height: 14,
  },
  [IconType.ContentHomeListDivider]: {
    srcDark: 'ic_content_home_list_divider_dark.svg',
    srcLight: 'ic_content_home_list_divider.svg',
    alt: '리스트 구분자',
    width: 10,
    height: 16,
  },
  [IconType.ContentHomeDot]: {
    srcDark: 'ic_content_home_dot_dark.svg',
    srcLight: 'ic_content_home_dot.svg',
    alt: '리스트 구분자',
    width: 6,
    height: 14,
  },
  [IconType.ContentHomeTimeStatic]: {
    srcStatic: 'ic_content_home_time_static.svg',
    alt: '기다무 뱃지',
    width: 18,
    height: 18,
  },
  [IconType.ContentHomeTime2Static]: {
    srcStatic: 'ic_content_home_time2_static.svg',
    alt: '기다무2 뱃지',
    width: 18,
    height: 18,
  },
  [IconType.ContentHome15Static]: {
    srcStatic: 'ic_content_home_15_static.svg',
    alt: '15세 뱃지',
    width: 18,
    height: 18,
  },
  [IconType.ContentHome19Static]: {
    srcStatic: 'ic_content_home_19_static.svg',
    alt: '19세 뱃지',
    width: 18,
    height: 18,
  },
  [IconType.ContentHome19SelfStatic]: {
    srcStatic: 'ic_content_home_19self_static.svg',
    alt: '자율심의 19세 뱃지',
    width: 18,
    height: 18,
  },
  [IconType.ContentHomeArrowSolid]: {
    srcDark: 'ic_content_home_arrow_solid_dark.svg',
    srcLight: 'ic_content_home_arrow_solid.svg',
    alt: '화살표',
    width: 24,
    height: 24,
  },
  [IconType.ContentHomeArrow02Solid]: {
    srcDark: 'ic_content_home_arrow_solid_02_dark.svg',
    srcLight: 'ic_content_home_arrow_02_solid.svg',
    alt: '화살표',
    width: 24,
    height: 24,
  },
  [IconType.ContentHomeArrowSolidStatic]: {
    srcStatic: 'ic_content_home_arrow_solid_static.svg',
    alt: '화살표',
    width: 24,
    height: 24,
  },
  [IconType.ContentHomePlayStatic]: {
    srcStatic: 'ic_content_home_play_static.svg',
    alt: '재생',
    width: 18,
    height: 18,
  },
  [IconType.ContentHomeFilter]: {
    srcLight: 'ic_content_home_filter.svg',
    srcDark: 'ic_content_home_filter_dark.svg',
    alt: '필터',
    width: 12,
    height: 12,
  },
  [IconType.ContentHomeArrowDown]: {
    srcLight: 'ic_content_home_arrow_down.svg',
    srcDark: 'ic_content_home_arrow_down_dark.svg',
    alt: '더보기',
    width: 12,
    height: 12,
  },
  [IconType.ContentHomeCheckOn]: {
    srcLight: 'ic_content_home_check_on.svg',
    srcDark: 'ic_content_home_check_on_dark.svg',
    alt: '체크 활성화',
    width: 12,
    height: 12,
  },
  [IconType.ContentHomeCheckOff]: {
    srcLight: 'ic_content_home_check_off.svg',
    srcDark: 'ic_content_home_check_off_dark.svg',
    alt: '체크 비활성화',
    width: 12,
    height: 12,
  },
  [IconType.ContentHomeAnchorStatic]: {
    srcStatic: 'ic_content_home_anchor_static.svg',
    alt: '보던 위치로',
    width: 40,
    height: 24,
  },
  [IconType.ContentHomeSaleset]: {
    srcDark: 'ic_content_home_saleset_dark.svg',
    srcLight: 'ic_content_home_saleset.svg',
    alt: '세트 상품 로고',
    width: 24,
    height: 24,
  },

  [IconType.ViewerGuideArrowLeftStatic]: {
    srcStatic: 'ic_viewer_guide_arrow_left_static.svg',
    alt: '왼쪽 넘기기',
    width: 24,
    height: 24,
  },
  [IconType.ViewerGuideArrowRightStatic]: {
    srcStatic: 'ic_viewer_guide_arrow_right_static.svg',
    alt: '오른쪽 넘기기',
    width: 24,
    height: 24,
  },
  [IconType.ViewerGuideArrowDownStatic]: {
    srcStatic: 'ic_viewer_guide_arrow_down_static.svg',
    alt: '아래로 내리기',
    width: 24,
    height: 24,
  },
  [IconType.ViewerGuideTouchStatic]: {
    srcStatic: 'ic_viewer_guide_touch_static.svg',
    alt: '터치 가이드',
    width: 24,
    height: 24,
  },
  [IconType.ViewerSoundStatic]: {
    srcStatic: 'ic_viewer_sound_static.svg',
    alt: '뷰어 소리 활성화 상태',
    width: 24,
    height: 25,
  },
  [IconType.ViewerMuteStatic]: {
    srcStatic: 'ic_viewer_mute_static.svg',
    alt: '뷰어 음소거 상태',
    width: 24,
    height: 25,
  },
  [IconType.ViewerThemeWhiteOffStatic]: {
    srcStatic: 'ic_viewer_theme_white_off_static.svg',
    alt: '화이트 테마 비활성화 상태',
    width: 32,
    height: 32,
  },
  [IconType.ViewerThemeWhiteOnStatic]: {
    srcStatic: 'ic_viewer_theme_white_on_static.svg',
    alt: '화이트 테마 활성화 상태',
    width: 32,
    height: 32,
  },
  [IconType.ViewerThemeLightGrayOffStatic]: {
    srcStatic: 'ic_viewer_theme_light_gray_off_static.svg',
    alt: '라이트그레이 테마 비활성화 상태',
    width: 32,
    height: 32,
  },
  [IconType.ViewerThemeLightGrayOnStatic]: {
    srcStatic: 'ic_viewer_theme_light_gray_on_static.svg',
    alt: '라이트그레이 테마 활성화 상태',
    width: 32,
    height: 32,
  },
  [IconType.ViewerThemeDarkGrayOffStatic]: {
    srcStatic: 'ic_viewer_theme_dark_gray_off_static.svg',
    alt: '다크그레이 테마 비활성화 상태',
    width: 32,
    height: 32,
  },
  [IconType.ViewerThemeDarkGrayOnStatic]: {
    srcStatic: 'ic_viewer_theme_dark_gray_on_static.svg',
    alt: '다크그레이 테마 활성화 상태',
    width: 32,
    height: 32,
  },
  [IconType.ViewerThemeBlackOffStatic]: {
    srcStatic: 'ic_viewer_theme_black_off_static.svg',
    alt: '블랙 테마 비활성화 상태',
    width: 32,
    height: 32,
  },
  [IconType.ViewerThemeBlackOnStatic]: {
    srcStatic: 'ic_viewer_theme_black_on_static.svg',
    alt: '블랙 테마 활성화 상태',
    width: 32,
    height: 32,
  },
  [IconType.ViewerThemeSepiaOffStatic]: {
    srcStatic: 'ic_viewer_theme_sepia_off_static.svg',
    alt: '세피아 테마 비활성화 상태',
    width: 32,
    height: 32,
  },
  [IconType.ViewerThemeSepiaOnStatic]: {
    srcStatic: 'ic_viewer_theme_sepia_on_static.svg',
    alt: '세피아 테마 활성화 상태',
    width: 32,
    height: 32,
  },
  [IconType.ViewerThemeGreenOffStatic]: {
    srcStatic: 'ic_viewer_theme_green_off_static.svg',
    alt: '그린 테마 비활성화 상태',
    width: 32,
    height: 32,
  },
  [IconType.ViewerThemeGreenOnStatic]: {
    srcStatic: 'ic_viewer_theme_green_on_static.svg',
    alt: '그린 테마 활성화 상태',
    width: 32,
    height: 32,
  },
  [IconType.ViewerMarginWhiteOffStatic]: {
    srcStatic: 'ic_viewer_margin_white_off_static.svg',
    alt: '흰색 여백 비활성화 상태',
    width: 32,
    height: 32,
  },
  [IconType.ViewerMarginWhiteOnStatic]: {
    srcStatic: 'ic_viewer_margin_white_on_static.svg',
    alt: '흰색 여백 활성화 상태',
    width: 32,
    height: 32,
  },
  [IconType.ViewerMarginBlackOffStatic]: {
    srcStatic: 'ic_viewer_margin_black_off_static.svg',
    alt: '검정 여백 비활성화 상태',
    width: 32,
    height: 32,
  },
  [IconType.ViewerMarginBlackOnStatic]: {
    srcStatic: 'ic_viewer_margin_black_on_static.svg',
    alt: '검정 여백 활성화 상태',
    width: 32,
    height: 32,
  },
  [IconType.ViewerBarList]: {
    srcDark: 'ic_viewer_bar_list_dark.svg',
    srcLight: 'ic_viewer_bar_list.svg',
    alt: '목록',
    width: 24,
    height: 24,
  },
  [IconType.ViewerBarTts]: {
    srcDark: 'ic_viewer_bar_tts_dark.svg',
    srcLight: 'ic_viewer_bar_tts.svg',
    alt: 'tts',
    width: 24,
    height: 24,
  },
  [IconType.ViewerBarComment]: {
    srcDark: 'ic_viewer_bar_comment_dark.svg',
    srcLight: 'ic_viewer_bar_comment.svg',
    alt: '댓글',
    width: 24,
    height: 24,
  },
  [IconType.ViewerBarArrowLeft]: {
    srcDark: 'ic_viewer_bar_arrow_left_dark.svg',
    srcLight: 'ic_viewer_bar_arrow_left.svg',
    alt: '이전',
    width: 24,
    height: 24,
  },
  [IconType.ViewerBarArrowRight]: {
    srcDark: 'ic_viewer_bar_arrow_right_dark.svg',
    srcLight: 'ic_viewer_bar_arrow_right.svg',
    alt: '다음',
    width: 24,
    height: 24,
  },
  [IconType.Viewer10sPrev]: {
    srcDark: 'ic_viewer_10s_prev_dark.svg',
    srcLight: 'ic_viewer_10s_prev.svg',
    alt: '10초전',
    width: 32,
    height: 32,
  },
  [IconType.Viewer10sNext]: {
    srcDark: 'ic_viewer_10s_next_dark.svg',
    srcLight: 'ic_viewer_10s_next.svg',
    alt: '10초뒤',
    width: 32,
    height: 32,
  },
  [IconType.ViewerSeekbarPrev]: {
    srcDark: 'ic_viewer_seekbar_prev_dark.svg',
    srcLight: 'ic_viewer_seekbar_prev.svg',
    alt: '이전',
    width: 18,
    height: 18,
  },
  [IconType.ViewerEnd]: {
    srcDark: 'ic_viewer_end_dark.svg',
    srcLight: 'ic_viewer_end.svg',
    alt: '뷰어엔드',
    width: 18,
    height: 18,
  },
  [IconType.ViewerEndStar]: {
    srcDark: 'ic_viewer_end_star_dark.svg',
    srcLight: 'ic_viewer_end_star.svg',
    alt: '별점',
    width: 24,
    height: 24,
  },
  [IconType.ViewerEndComment]: {
    srcDark: 'ic_viewer_end_comment_dark.svg',
    srcLight: 'ic_viewer_end_comment.svg',
    alt: '댓글',
    width: 24,
    height: 24,
  },
  [IconType.ViewerEndCommentOff]: {
    srcDark: 'ic_viewer_end_comment_off_dark.svg',
    srcLight: 'ic_viewer_end_comment_off.svg',
    alt: '댓글 off',
    width: 16,
    height: 16,
  },
  [IconType.ViewerEndCommentOn]: {
    srcDark: 'ic_viewer_end_comment_on_dark.svg',
    srcLight: 'ic_viewer_end_comment_on.svg',
    alt: '댓글 on',
    width: 16,
    height: 16,
  },
  [IconType.ViewerNextChapter]: {
    srcDark: 'ic_viewer_next_chapter_dark.svg',
    srcLight: 'ic_viewer_next_chapter.svg',
    alt: '다음챕터',
    width: 74,
    height: 24,
  },
  [IconType.ViewerSettingBrightness]: {
    srcDark: 'ic_viewer_setting_brightness_dark.svg',
    srcLight: 'ic_viewer_setting_brightness.svg',
    alt: '밝기조절',
    width: 18,
    height: 18,
  },
  [IconType.ViewerSettingRefresh]: {
    srcDark: 'ic_viewer_setting_refresh_dark.svg',
    srcLight: 'ic_viewer_setting_refresh.svg',
    alt: '새로고침',
    width: 18,
    height: 18,
  },
  [IconType.ViewerPlayM]: {
    srcDark: 'ic_viewer_play_m_dark.svg',
    srcLight: 'ic_viewer_play_m.svg',
    alt: '재생',
    width: 32,
    height: 32,
  },
  [IconType.ViewerPauseM]: {
    srcDark: 'ic_viewer_pause_m_dark.svg',
    srcLight: 'ic_viewer_pause_m.svg',
    alt: '일시정지',
    width: 32,
    height: 32,
  },
  [IconType.ViewerReplyM]: {
    srcDark: 'ic_viewer_replay_m_dark.svg',
    srcLight: 'ic_viewer_replay_m.svg',
    alt: '다시 재생',
    width: 32,
    height: 32,
  },
  [IconType.ViewerFontGothicOff]: {
    srcDark: 'ic_viewer_font_gothic_off_dark.svg',
    srcLight: 'ic_viewer_font_gothic_off.svg',
    alt: '고딕 폰트 비활성화 상태',
    width: 36,
    height: 18,
  },
  [IconType.ViewerFontGothicOn]: {
    srcDark: 'ic_viewer_font_gothic_on_dark.svg',
    srcLight: 'ic_viewer_font_gothic_on.svg',
    alt: '고딕 폰트 활성화 상태',
    width: 36,
    height: 18,
  },
  [IconType.ViewerFontBatangOff]: {
    srcDark: 'ic_viewer_font_batang_off_dark.svg',
    srcLight: 'ic_viewer_font_batang_off.svg',
    alt: '바탕 폰트 비활성화 상태',
    width: 36,
    height: 18,
  },
  [IconType.ViewerFontBatangOn]: {
    srcDark: 'ic_viewer_font_batang_on_dark.svg',
    srcLight: 'ic_viewer_font_batang_on.svg',
    alt: '바탕 폰트 활성화 상태',
    width: 36,
    height: 18,
  },
  [IconType.ViewerFontMyungjoOff]: {
    srcDark: 'ic_viewer_font_myungjo_off_dark.svg',
    srcLight: 'ic_viewer_font_myungjo_off.svg',
    alt: '명조 폰트 비활성화 상태',
    width: 36,
    height: 18,
  },
  [IconType.ViewerFontMyungjoOn]: {
    srcDark: 'ic_viewer_font_myungjo_on_dark.svg',
    srcLight: 'ic_viewer_font_myungjo_on.svg',
    alt: '명조 폰트 활성화 상태',
    width: 36,
    height: 18,
  },
  [IconType.ViewerTtsPlaySDark]: {
    srcDark: 'ic_viewer_tts_play_s_dark.svg',
    srcLight: 'ic_viewer_tts_play_s_dark.svg',
    alt: '재생',
    width: 24,
    height: 24,
  },
  [IconType.ViewerTtsPauseSDark]: {
    srcDark: 'ic_viewer_tts_pause_s_dark.svg',
    srcLight: 'ic_viewer_tts_pause_s_dark.svg',
    alt: '일시정지',
    width: 24,
    height: 24,
  },
  [IconType.ViewerTtsPrevDark]: {
    srcDark: 'ic_viewer_tts_prev_dark.svg',
    srcLight: 'ic_viewer_tts_prev_dark.svg',
    alt: '이전',
    width: 32,
    height: 32,
  },
  [IconType.ViewerTtsNextDark]: {
    srcDark: 'ic_viewer_tts_next_dark.svg',
    srcLight: 'ic_viewer_tts_next_dark.svg',
    alt: '다음',
    width: 32,
    height: 32,
  },
  [IconType.ViewerSeekbarExpandDark]: {
    srcDark: 'ic_viewer_seekbar_expand_dark.svg',
    srcLight: 'ic_viewer_seekbar_expand_dark.svg',
    alt: '확장',
    width: 18,
    height: 18,
  },
  [IconType.ViewerSeekbarReduceDark]: {
    srcDark: 'ic_viewer_seekbar_reduce_dark.svg',
    srcLight: 'ic_viewer_seekbar_reduce_dark.svg',
    alt: '감소',
    width: 18,
    height: 18,
  },
  [IconType.ViewerAudioPlayMDark]: {
    srcDark: 'ic_viewer_audio_play_m_dark.svg',
    srcLight: 'ic_viewer_audio_play_m_dark.svg',
    alt: '재생',
    width: 32,
    height: 32,
  },
  [IconType.ViewerAudioPauseMDark]: {
    srcDark: 'ic_viewer_audio_pause_m_dark.svg',
    srcLight: 'ic_viewer_audio_pause_m_dark.svg',
    alt: '일시정지',
    width: 32,
    height: 32,
  },
  [IconType.ViewerAudioCloseMDark]: {
    srcDark: 'ic_viewer_audio_close_m_dark.svg',
    srcLight: 'ic_viewer_audio_close_m_dark.svg',
    alt: '닫기',
    width: 32,
    height: 32,
  },
  [IconType.ViewerPlayLDark]: {
    srcDark: 'ic_viewer_play_l_dark.svg',
    srcLight: 'ic_viewer_play_l_dark.svg',
    alt: '재생',
    width: 40,
    height: 40,
  },
  [IconType.ViewerPauseLDark]: {
    srcDark: 'ic_viewer_pause_l_dark.svg',
    srcLight: 'ic_viewer_pause_l_dark.svg',
    alt: '일시정지',
    width: 40,
    height: 40,
  },
  [IconType.ViewerReplayLDark]: {
    srcDark: 'ic_viewer_replay_l_dark.svg',
    srcLight: 'ic_viewer_replay_l_dark.svg',
    alt: '다시 재생',
    width: 40,
    height: 58,
  },
  [IconType.ViewerStarMask]: {
    srcDark: 'ic_viewer_star_mask_dark.svg',
    srcLight: 'ic_viewer_star_mask.svg',
    alt: '별점',
    width: 28,
    height: 28,
  },
  [IconType.ViewerStarHalf]: {
    srcDark: 'ic_viewer_star_half_dark.svg',
    srcLight: 'ic_viewer_star_half.svg',
    alt: '별점 반개',
    width: 28,
    height: 28,
  },
  [IconType.ViewerStarOff]: {
    srcDark: 'ic_viewer_star_off_dark.svg',
    srcLight: 'ic_viewer_star_off.svg',
    alt: '별점 없음',
    width: 28,
    height: 28,
  },
  [IconType.ViewerStarOn]: {
    srcStatic: 'ic_viewer_star_on_static.svg',
    alt: '별점 있음',
    width: 28,
    height: 28,
  },
  [IconType.ViewerTop]: {
    srcDark: 'ic_viewer_top_pc_dark.svg',
    srcLight: 'ic_viewer_top_pc.svg',
    alt: '상단으로',
    width: 28,
    height: 28,
  },
  [IconType.ViewerStart]: {
    srcDark: 'ic_viewer_start_pc_dark.svg',
    srcLight: 'ic_viewer_start_pc.svg',
    alt: '처음으로',
    width: 28,
    height: 28,
  },
  [IconType.ViewerArrowLeft]: {
    srcDark: 'ic_viewer_arrow_left_dark.svg',
    srcLight: 'ic_viewer_arrow_left.svg',
    alt: '이전',
    width: 32,
    height: 32,
  },
  [IconType.ViewerArrowRight]: {
    srcDark: 'ic_viewer_arrow_right_dark.svg',
    srcLight: 'ic_viewer_arrow_right.svg',
    alt: '다음',
    width: 32,
    height: 32,
  },
  [IconType.ViewerReplayDark]: {
    srcDark: 'ic_viewer_replay_dark.svg',
    srcLight: 'ic_viewer_replay_dark.svg',
    alt: '다시 재생',
    width: 40,
    height: 40,
  },
  [IconType.Viewer10sNextStatic]: {
    srcStatic: 'ic_viewer_10s_next_web_static.svg',
    alt: '10초 후로 이동',
    width: 32,
    height: 32,
  },
  [IconType.Viewer10sPrevStatic]: {
    srcStatic: 'ic_viewer_10s_prev_web_static.svg',
    alt: '10초 전으로 이동',
    width: 32,
    height: 32,
  },
  [IconType.ViewerPauseStatic]: {
    srcStatic: 'ic_viewer_pause_l_web_static.svg',
    alt: '일시정지',
    width: 40,
    height: 40,
  },
  [IconType.ViewerPlayStatic]: {
    srcStatic: 'ic_viewer_play_l_web_static.svg',
    alt: '재생',
    width: 40,
    height: 40,
  },
  [IconType.ViewerReplayStatic]: {
    srcStatic: 'ic_viewer_replay_l_mw_static.svg',
    alt: '다시재생',
    width: 40,
    height: 58,
  },
  [IconType.ViewerReplayPcStatic]: {
    srcStatic: 'ic_viewer_replay_pc_static.svg',
    alt: '다시재생',
    width: 40,
    height: 40,
  },
  [IconType.ViewerSeekbarExpandStatic]: {
    srcStatic: 'ic_viewer_seekbar_expand_web_static.svg',
    alt: '전체화면',
    width: 18,
    height: 18,
  },
  [IconType.MoreNoticeSolidRedStatic]: {
    srcStatic: 'ic_more_notice_solid_red_static.svg',
    alt: '안내',
    width: 12,
    height: 16,
  },
  [IconType.CommentEmojiOffStatic]: {
    srcStatic: 'ic_comment_emoji_off_static.svg',
    alt: '이모티콘',
    width: 18,
    height: 18,
  },
  [IconType.CommentEmojiOnStatic]: {
    srcStatic: 'ic_comment_emoji_on_static.svg',
    alt: '이모티콘',
    width: 18,
    height: 18,
  },
  [IconType.CommentUploadStatic]: {
    srcStatic: 'ic_comment_upload_static.svg',
    alt: '업로드',
    width: 30,
    height: 30,
  },
  [IconType.ReverseMain]: {
    srcStatic: 'ic_reverse_main.png',
    alt: '소녀리버스',
    width: 276,
    height: 68,
  },
  [IconType.HelixHelpButtonStatic]: {
    srcStatic: 'helix_ic_button_help_static.svg',
    alt: '도움말',
    width: 14,
    height: 14,
  },
  [IconType.InputboxDelete]: {
    srcLight: 'ic_inputbox_delete.svg',
    srcDark: 'ic_inputbox_delete_dark.svg',
    alt: '인풋 텍스트 제거',
    width: 20,
    height: 20,
  },
  [IconType.InputboxShowOn]: {
    srcLight: 'ic_inputbox_show_on.svg',
    srcDark: 'ic_inputbox_show_on_dark.svg',
    alt: '인풋 패스워드 노출 토글',
    width: 20,
    height: 20,
  },
  [IconType.InputboxShowOff]: {
    srcLight: 'ic_inputbox_show_off.svg',
    srcDark: 'ic_inputbox_show_off_dark.svg',
    alt: '인풋 패스워드 미노출 토글',
    width: 20,
    height: 20,
  },
  [IconType.NavigationComment]: {
    srcDark: 'ic_navigation_comment_dark.svg',
    srcLight: 'ic_navigation_comment.svg',
    alt: '댓글',
    width: 24,
    height: 24,
  },
  [IconType.NavigationContentsHomeStatic]: {
    srcStatic: 'ic_navigation_contents_home_static.svg',
    alt: '컨텐츠홈',
    width: 24,
    height: 24,
  },
  [IconType.NavigationGiftWeb]: {
    srcLight: 'ic_navigation_gift_web.svg',
    srcDark: 'ic_navigation_gift_web_dark.svg',
    alt: '선물',
    width: 24,
    height: 24,
  },
  [IconType.NavigationHeartOn]: {
    srcLight: 'ic_navigation_heart_on.svg',
    srcDark: 'ic_navigation_heart_on_dark.svg',
    alt: '좋아요 활성화 상태',
    width: 24,
    height: 24,
  },
  [IconType.NavigationHomeMw]: {
    srcLight: 'ic_navigation_home_mw.svg',
    srcDark: 'ic_navigation_home_mw_dark.svg',
    alt: '홈',
    width: 24,
    height: 24,
  },
  [IconType.NavigationHomeMwStatic]: {
    srcStatic: 'ic_navigation_home_mw_static.svg',
    alt: '홈',
    width: 24,
    height: 24,
  },
  [IconType.NavigationMyWeb]: {
    srcLight: 'ic_navigation_my_web.svg',
    srcDark: 'ic_navigation_my_web_dark.svg',
    alt: '내 정보',
    width: 24,
    height: 24,
  },
  [IconType.NavigationPagePc]: {
    srcLight: 'ic_navigation_page_pc.svg',
    srcDark: 'ic_navigation_page_pc_dark.svg',
    alt: '페이지',
    width: 24,
    height: 24,
  },
  [IconType.NavigationRunmodeOff]: {
    srcLight: 'ic_navigation_runmode_off.svg',
    srcDark: 'ic_navigation_runmode_off_dark.svg',
    alt: '정주행 비활성화 상태',
    width: 24,
    height: 24,
  },
  [IconType.NavigationRunmodeOnStatic]: {
    srcStatic: 'ic_navigation_runmode_on_static.svg',
    alt: '정주행 활성화 상태',
    width: 24,
    height: 24,
  },
  [IconType.NavigationScrollPc]: {
    srcLight: 'ic_navigation_scroll_pc.svg',
    srcDark: 'ic_navigation_scroll_pc_dark.svg',
    alt: '스크롤',
    width: 24,
    height: 24,
  },
  [IconType.NavigationSoundOffStatic]: {
    srcStatic: 'ic_navigation_soundoff_static.svg',
    alt: '소리 비활성화 상태',
    width: 24,
    height: 24,
  },
  [IconType.NavigationSoundOnStatic]: {
    srcStatic: 'ic_navigation_soundon_static.svg',
    alt: '소리 활성화 상태',
    width: 24,
    height: 24,
  },
  [IconType.SearchButtonPc]: {
    srcLight: 'ic_search_button_pc.svg',
    srcDark: 'ic_search_button_pc_dark.svg',
    alt: '검색',
    width: 24,
    height: 24,
  },
  [IconType.ViewerScene]: {
    srcLight: 'ic_viewer_scene.svg',
    srcDark: 'ic_viewer_scene_dark.svg',
    alt: '장면',
    width: 32,
    height: 32,
  },
  [IconType.NavigationGiftWebDark]: {
    srcDark: 'ic_navigation_gift_web_dark.svg',
    srcLight: 'ic_navigation_gift_web.svg',
    alt: '선물',
    width: 24,
    height: 24,
  },
  [IconType.NavigationHeartOnDark]: {
    srcDark: 'ic_navigation_heart_on_dark.svg',
    srcLight: 'ic_navigation_heart_on.svg',
    alt: '좋아요 활성화 상태',
    width: 24,
    height: 24,
  },
  [IconType.NavigationHomeMwDark]: {
    srcDark: 'ic_navigation_home_mw_dark.svg',
    srcLight: 'ic_navigation_home_mw.svg',
    alt: '홈',
    width: 24,
    height: 24,
  },
  [IconType.NavigationMyWebDark]: {
    srcDark: 'ic_navigation_my_web_dark.svg',
    srcLight: 'ic_navigation_my_web.svg',
    alt: '내 정보',
    width: 24,
    height: 24,
  },
  [IconType.NavigationPagePcDark]: {
    srcDark: 'ic_navigation_page_pc_dark.svg',
    srcLight: 'ic_navigation_page_pc.svg',
    alt: '페이지',
    width: 24,
    height: 24,
  },
  [IconType.NavigationRunmodeOffDark]: {
    srcDark: 'ic_navigation_runmode_off_dark.svg',
    srcLight: 'ic_navigation_runmode_off.svg',
    alt: '정주행 비활성화 상태',
    width: 24,
    height: 24,
  },
  [IconType.NavigationScrollPcDark]: {
    srcDark: 'ic_navigation_scroll_pc_dark.svg',
    srcLight: 'ic_navigation_scroll_pc.svg',
    alt: '스크롤',
    width: 24,
    height: 24,
  },
  [IconType.SearchButtonPcDark]: {
    srcDark: 'ic_search_button_pc_dark.svg',
    srcLight: 'ic_search_button_pc.svg',
    alt: '검색',
    width: 24,
    height: 24,
  },
  [IconType.ViewerSceneDark]: {
    srcDark: 'ic_viewer_scene_dark.svg',
    srcLight: 'ic_viewer_scene.svg',
    alt: '장면',
    width: 32,
    height: 32,
  },
  [InternalStaticImageType.ShortcutHome]: {
    srcStatic: 'img_shortcut_home.png',
    alt: '취향 홈',
    width: 136,
    height: 136,
  },
  [InternalStaticImageType.ShortcutWebtoon]: {
    srcStatic: 'img_shortcut_webtoon.png',
    alt: '웹툰 홈',
    width: 136,
    height: 136,
  },
  [InternalStaticImageType.ShortcutWebNovel]: {
    srcStatic: 'img_shortcut_webnovel.png',
    alt: '웹소설 홈',
    width: 136,
    height: 136,
  },
  [InternalStaticImageType.ShortcutBook]: {
    srcStatic: 'img_shortcut_book.png',
    alt: '책 홈',
    width: 136,
    height: 136,
  },
  [InternalStaticImageType.Shortcut1]: {
    srcStatic: 'img_shortcut_1.png',
    alt: '바로가기 이미지',
    width: 128,
    height: 128,
  },
  [InternalStaticImageType.Shortcut2]: {
    srcStatic: 'img_shortcut_2.png',
    alt: '바로가기 이미지',
    width: 128,
    height: 128,
  },
  [InternalStaticImageType.Shortcut3]: {
    srcStatic: 'img_shortcut_3.png',
    alt: '바로가기 이미지',
    width: 128,
    height: 128,
  },
  [InternalStaticImageType.Shortcut4]: {
    srcStatic: 'img_shortcut_4.png',
    alt: '바로가기 이미지',
    width: 128,
    height: 128,
  },
  [InternalStaticImageType.Shortcut5]: {
    srcStatic: 'img_shortcut_5.png',
    alt: '바로가기 이미지',
    width: 128,
    height: 128,
  },
  [InternalStaticImageType.Shortcut6]: {
    srcStatic: 'img_shortcut_6.png',
    alt: '바로가기 이미지',
    width: 128,
    height: 128,
  },
  [InternalStaticImageType.Shortcut7]: {
    srcStatic: 'img_shortcut_7.png',
    alt: '바로가기 이미지',
    width: 128,
    height: 128,
  },
  [InternalStaticImageType.Shortcut8]: {
    srcStatic: 'img_shortcut_8.png',
    alt: '바로가기 이미지',
    width: 128,
    height: 128,
  },
  [InternalStaticImageType.Shortcut9]: {
    srcStatic: 'img_shortcut_9.png',
    alt: '바로가기 이미지',
    width: 128,
    height: 128,
  },
  [InternalStaticImageType.Shortcut10]: {
    srcStatic: 'img_shortcut_10.png',
    alt: '바로가기 이미지',
    width: 128,
    height: 128,
  },
  [InternalStaticImageType.Shortcut11]: {
    srcStatic: 'img_shortcut_11.png',
    alt: '바로가기 이미지',
    width: 128,
    height: 128,
  },
  [InternalStaticImageType.Shortcut12]: {
    srcStatic: 'img_shortcut_12.png',
    alt: '바로가기 이미지',
    width: 128,
    height: 128,
  },
  [InternalStaticImageType.Shortcut13]: {
    srcStatic: 'img_shortcut_13.png',
    alt: '바로가기 이미지',
    width: 128,
    height: 128,
  },
  [InternalStaticImageType.Shortcut14]: {
    srcStatic: 'img_shortcut_14.png',
    alt: '바로가기 이미지',
    width: 128,
    height: 128,
  },
  [InternalStaticImageType.Shortcut15]: {
    srcStatic: 'img_shortcut_15.png',
    alt: '바로가기 이미지',
    width: 128,
    height: 128,
  },
  [InternalStaticImageType.Shortcut16]: {
    srcStatic: 'img_shortcut_16.png',
    alt: '바로가기 이미지',
    width: 128,
    height: 128,
  },
  [InternalStaticImageType.Shortcut17]: {
    srcStatic: 'img_shortcut_17.png',
    alt: '바로가기 이미지',
    width: 128,
    height: 128,
  },
  [InternalStaticImageType.Shortcut18]: {
    srcStatic: 'img_shortcut_18.png',
    alt: '바로가기 이미지',
    width: 128,
    height: 128,
  },
  [InternalStaticImageType.Shortcut19]: {
    srcStatic: 'img_shortcut_19.png',
    alt: '바로가기 이미지',
    width: 128,
    height: 128,
  },
  [InternalStaticImageType.Shortcut20]: {
    srcStatic: 'img_shortcut_20.png',
    alt: '바로가기 이미지',
    width: 128,
    height: 128,
  },
  [InternalStaticImageType.Shortcut21]: {
    srcStatic: 'img_shortcut_21.png',
    alt: '바로가기 이미지',
    width: 128,
    height: 128,
  },
  [InternalStaticImageType.Shortcut22]: {
    srcStatic: 'img_shortcut_22.png',
    alt: '바로가기 이미지',
    width: 128,
    height: 128,
  },
  [InternalStaticImageType.Shortcut23]: {
    srcStatic: 'img_shortcut_23.png',
    alt: '바로가기 이미지',
    width: 128,
    height: 128,
  },
  [InternalStaticImageType.Shortcut24]: {
    srcStatic: 'img_shortcut_24.png',
    alt: '바로가기 이미지',
    width: 128,
    height: 128,
  },
  [InternalStaticImageType.Shortcut25]: {
    srcStatic: 'img_shortcut_25.png',
    alt: '바로가기 이미지',
    width: 128,
    height: 128,
  },
  [InternalStaticImageType.Shortcut26]: {
    srcStatic: 'img_shortcut_26.png',
    alt: '바로가기 이미지',
    width: 128,
    height: 128,
  },
  [InternalStaticImageType.Shortcut27]: {
    srcStatic: 'img_shortcut_27.png',
    alt: '바로가기 이미지',
    width: 128,
    height: 128,
  },
  [InternalStaticImageType.Shortcut28]: {
    srcStatic: 'img_shortcut_28.png',
    alt: '바로가기 이미지',
    width: 128,
    height: 128,
  },
  [InternalStaticImageType.Shortcut29]: {
    srcStatic: 'img_shortcut_29.png',
    alt: '바로가기 이미지',
    width: 128,
    height: 128,
  },
  [InternalStaticImageType.Shortcut30]: {
    srcStatic: 'img_shortcut_30.png',
    alt: '바로가기 이미지',
    width: 128,
    height: 128,
  },
  [InternalStaticImageType.Shortcut31]: {
    srcStatic: 'img_shortcut_31.png',
    alt: '바로가기 이미지',
    width: 128,
    height: 128,
  },
  [InternalStaticImageType.Shortcut32]: {
    srcStatic: 'img_shortcut_32.png',
    alt: '바로가기 이미지',
    width: 128,
    height: 128,
  },
  [InternalStaticImageType.Shortcut33]: {
    srcStatic: 'img_shortcut_33.png',
    alt: '바로가기 이미지',
    width: 128,
    height: 128,
  },
  [InternalStaticImageType.Shortcut34]: {
    srcStatic: 'img_shortcut_34.png',
    alt: '바로가기 이미지',
    width: 128,
    height: 128,
  },
  [InternalStaticImageType.Shortcut35]: {
    srcStatic: 'img_shortcut_35.png',
    alt: '바로가기 이미지',
    width: 128,
    height: 128,
  },
  [InternalStaticImageType.Shortcut36]: {
    srcStatic: 'img_shortcut_36.png',
    alt: '바로가기 이미지',
    width: 128,
    height: 128,
  },
  [InternalStaticImageType.Shortcut37]: {
    srcStatic: 'img_shortcut_37.png',
    alt: '바로가기 이미지',
    width: 128,
    height: 128,
  },
  [InternalStaticImageType.Shortcut38]: {
    srcStatic: 'img_shortcut_38.png',
    alt: '바로가기 이미지',
    width: 128,
    height: 128,
  },
  [InternalStaticImageType.Spinner]: {
    srcStatic: 'spinner.svg',
    alt: '스피너',
    width: 200,
    height: 200,
  },
  [InternalStaticImageType.ThubmnailLoadingBiStatic]: {
    srcStatic: 'img_thumbnail_loading_bi_static.svg',
    alt: '로딩',
    width: 32,
    height: 32,
  },
  [InternalStaticImageType.ExceptionLoadingBi]: {
    srcDark: 'img_exception_loading_bi_dark.svg',
    srcLight: 'img_exception_loading_bi.svg',
    alt: '로딩',
    width: 60,
    height: 60,
  },
  [InternalStaticImageType.LoadingStatic]: {
    srcStatic: 'img_loading_static.svg',
    alt: '로딩중',
    width: 32,
    height: 32,
  },
  [InternalStaticImageType.LoadingImageErrorWebStatic]: {
    srcStatic: 'img_loading_image_error_web_static.svg',
    alt: '이미지 로드 실패',
    width: 40,
    height: 40,
  },
  [InternalStaticImageType.CashBannerHelixStatic]: {
    srcStatic: 'img_cash_banner_helix_static@2x.png',
    alt: '헬릭스 캐시 배너',
    width: 160,
    height: 64,
  },
  [InternalStaticImageType.CashBannerRecentStatic]: {
    srcStatic: 'img_cash_banner_recent_static@2x.png',
    alt: '최근감상 캐시 배너',
    width: 160,
    height: 64,
  },
  [InternalStaticImageType.CashBannerMillionStatic]: {
    srcStatic: 'img_cash_banner_million_static@2x.png',
    alt: '밀리언페이지 캐시 배너',
    width: 160,
    height: 64,
  },
  [InternalStaticImageType.HelixLogoStatic]: {
    srcStatic: 'helix_logo_static.svg',
    alt: '헬릭스 로고',
    width: 64,
    height: 14,
  },
  [InternalStaticImageType.ImgSplashLight]: {
    srcStatic: 'img_splash_light.png',
    alt: '스플래시 라이트',
    width: 48,
    height: 48,
  },
  [IconType.FilterSorting]: {
    srcStatic: 'ic_filter_sorting.svg',
    alt: '정렬',
    width: 12,
    height: 12,
  },
};

Object.keys(INTERNAL_STATIC_IMAGE_INFO_MAP).forEach(key => {
  INTERNAL_STATIC_IMAGE_INFO_MAP[
    key as IconType | InternalStaticImageType
  ].isInternal = true;
});

export {INTERNAL_STATIC_IMAGE_INFO_MAP};
